import { AuthResponse, User } from '../types';
import apiService from './api';

class AuthService {
  async login(email: string, password: string): Promise<AuthResponse> {
    try {
      const response = await apiService.post<{ token: string; user: User }>('/auth/login', {
        email,
        password,
      });

      if (response.status === 200 && response.data?.token) {
        // Armazenar token no sessionStorage
        sessionStorage.setItem('psd_token', response.data.token);
        return {
          success: true,
          token: response.data.token,
        };
      }

      // Login falhou - retornar erro específico baseado no status
      let errorMessage = 'Credenciais inválidas';
      if (response.status === 401) {
        errorMessage = 'Email ou senha incorretos. Verifique suas credenciais.';
      } else if (response.status >= 500) {
        errorMessage = 'Erro interno do servidor. Tente novamente mais tarde.';
      } else if (response.error) {
        errorMessage = response.error;
      }

      return {
        success: false,
        error: errorMessage,
      };
    } catch (error) {
      return {
        success: false,
        error: 'Erro de comunicação com o servidor',
      };
    }
  }

  async logout(): Promise<void> {
    try {
      await apiService.post('/auth/logout');
    } catch (error) {
      // Ignora erro do logout no servidor
    } finally {
      // Remove token do storage
      sessionStorage.removeItem('psd_token');
    }
  }

  async validateToken(): Promise<User | null> {
    const token = sessionStorage.getItem('psd_token');
    if (!token) return null;

    const response = await apiService.get<{
      account_id: string;
      user_id?: string;
      company_id?: string;
      role?: string;
      email?: string;
      name?: string;
    }>('/auth/validate');
    
    if (response.status === 200 && response.data?.account_id) {
      return {
        account_id: response.data.account_id,
        email: response.data.email || '',
        name: response.data.name,
        user_id: response.data.user_id,
        company_id: response.data.company_id,
        role: response.data.role,
      };
    }

    // Token inválido, remove do storage
    sessionStorage.removeItem('psd_token');
    return null;
  }

  getToken(): string | null {
    return sessionStorage.getItem('psd_token');
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }
}

const authService = new AuthService();
export default authService;